import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { localGet, localSet } from '../../utils/localStorage';
import { SidebarContainer } from '../Sidebar';
import RouteContent from '../RouteContent';
import './style.css';

class WithSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSidebarExtended: localGet('sidebarExtended', true, true),
    };
    this.resizeSidebar = this.resizeSidebar.bind(this);
  }

  resizeSidebar() {
    this.setState((prevState) => {
      const isSidebarExtended = !prevState.isSidebarExtended;
      localSet('sidebarExtended', isSidebarExtended);
      return { isSidebarExtended };
    });
  }

  render() {
    const { isSidebarExtended } = this.state;
    const { children, ...rest } = this.props;

    return (
      <div className="container">
        <SidebarContainer
          resizeSidebar={this.resizeSidebar}
          isSidebarExtended={isSidebarExtended}
          {...rest}
        />
        <RouteContent {...rest}>
          {children}
        </RouteContent>
      </div>
    );
  }
}

WithSidebar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WithSidebar;



// WEBPACK FOOTER //
// ./src/components/WithSidebar/WithSidebar.js